module.exports = __webpack_public_path__ + "img/equipment-item-1.88db08f.png";